// extracted by mini-css-extract-plugin
export default {"box":"refundDetailPage_box__-Gjm9","box__order__detail":"refundDetailPage_box__order__detail__UMssJ"};